/**
 * Generic scoring for match sessions. Difficulty-ramping via streak + speed bonus.
 */
export class ScoringSystem {
  static readonly BASE_POINTS = 10;
  static readonly STREAK_MULT_STEP = 0.1;
  static readonly STREAK_MULT_CAP = 3.0;
  static readonly SPEED_BONUS_MS = 3000;
  static readonly SPEED_BONUS_POINTS = 5;

  static forCorrect(streak: number, elapsedMs: number): number {
    const streakMult = Math.min(
      1 + streak * ScoringSystem.STREAK_MULT_STEP,
      ScoringSystem.STREAK_MULT_CAP
    );
    const speedBonus = elapsedMs < ScoringSystem.SPEED_BONUS_MS ? ScoringSystem.SPEED_BONUS_POINTS : 0;
    return Math.round(ScoringSystem.BASE_POINTS * streakMult + speedBonus);
  }
}
